export default __webpack_public_path__ + "static/media/screenout.a9e32664.svg";